import { render, staticRenderFns } from "./BaseNumberCard.vue?vue&type=template&id=4ac5e482&"
import script from "./BaseNumberCard.vue?vue&type=script&lang=js&"
export * from "./BaseNumberCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports